import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';

import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Badge from '@mui/material/Badge';

const TabMenu = ({ alertCount, handleAlertClick, handleOverviewClick, value }) => {
  return (
    <Tabs
      onChange={(__, newValue) => {
        if (R.equals(newValue, 'alerts')) handleAlertClick();
        else if (R.equals(newValue, 'overview')) handleOverviewClick();
      }}
      sx={{
        '& .MuiTabs-flexContainer': { justifyContent: { sm: 'flex-start', xs: 'center' } },
        backgroundColor: 'surface.white',
        pl: { sm: 7, xs: 0 },
      }}
      value={value}
    >
      <Tab
        label={
          <Box>
            <Badge
              invisible={!alertCount}
              sx={{
                '.MuiBadge-badge': {
                  backgroundColor: 'error.dark',
                  right: -10,
                  top: '10%',
                },
              }}
              variant="dot"
            >
              Alerts
            </Badge>
          </Box>
        }
        value="alerts"
      />
      <Tab label="Overview" sx={{ mr: { sm: 0, xs: 7 } }} value="overview" />
    </Tabs>
  );
};

TabMenu.propTypes = {
  alertCount: PropTypes.number,
  handleAlertClick: PropTypes.func.isRequired,
  handleOverviewClick: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

TabMenu.defaultProps = {
  alertCount: 0,
};

export default TabMenu;
